import { render, staticRenderFns } from "./OMThankYou.vue?vue&type=template&id=6d850a69&"
import script from "./OMThankYou.vue?vue&type=script&lang=js&"
export * from "./OMThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports